module.exports = __webpack_public_path__ + "static/media/img_wear-remove-02.3d6f7be8.svg";